import { AuthLevel, generateApiPath } from '@guiker/api-definition'

import { config } from '../../config'

const paths = {
  paymentVerification: generateApiPath({ prefix: AuthLevel.AUTH, name: config.domainName }),
}

export { paths }
